import SvgIcon from '@mui/material/SvgIcon';
import { ReactComponent as DeleteReportIconSvg } from '../../../assets/icons/delete-report.svg';

export default function DeleteReportIcon() {
  return <SvgIcon component={DeleteReportIconSvg} sx={{ '& path': { fill: 'white' } }} />;
}
